import projects_data from "./projects.json"

export type ProjectType = {
    id: number,
    title: string,
    subtitle: string,
    title_img_url: string,
    small_title_img_url: string,
    anim?: string,
    client: string,
    year: number,
    project_type: string,
    field: string,
    info: string,
    image_urls: Array<string>
}

var proj = projects_data.reverse()

export const fetchAllProjects = () => {
    return proj.slice(0, 8)
}

export const fetchFilteredprojects = (filter: string) => {
    if (filter === '') {
        return proj.slice(0, 8)
    }
    return proj.filter((p) => p.project_type === filter).slice(0, 8)
}

export const getProjectById = (id: number) => {
    return projects_data.find((project) => project.id === id) || projects_data[0]
}